var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.achievedTrophies),function(trophy){return _c('div',{key:trophy.id,staticClass:"flex-child"},[_c('trophy',{staticStyle:{"width":"90%"},attrs:{"size":"57","displayOnly":true,"trophy":trophy,"showTitle":false,"showDesc":false,"orientation":"horizontal"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }